"use strict";
/**
 * POST 请求
 *
 * ### Example
 * ```
 * post({
 *     url: '/api/test',
 *     data: {
 *         token: '123',
 *         address: 'http://i.meituan.com'
 *     },
 *     callback: (res, err) => {
 *          console.log(res);
 *          console.log(err);
 *     }
 * });
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
var object_to_query_1 = require("./object-to-query");
function post(config) {
    var url = config.url, data = config.data, callback = config.callback;
    if (data !== void 0) {
        url += '?' + object_to_query_1.objectToQuery(data);
    }
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
            if (xhr.status >= 200 && xhr.status < 300) {
                callback(JSON.parse(xhr.responseText));
            }
            else {
                callback(null, xhr);
            }
        }
    };
    xhr.open('post', url, true);
    xhr.timeout = 8000;
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.send();
}
exports.post = post;
